import React from "react";
import StickyHeadTable from "./StickyHeadTable";
import { isMobile } from "react-device-detect";
import dateFormat from "dateformat";
import { styled } from "@mui/material/styles";
import PageWrapper from "./layout/PageWrapper";
import RecordsBox from "./RecordsBox";

const SelectionText = styled("span")(({ theme }) => ({
  display: "inline-block",
  marginLeft: 20,
}));

const AdminCustomers = function (props) {
  const {
    customers: items,
    businessType,
    superUser,
    onDelete,
    onEdit,
    onRefreshData,
  } = props;

  const [itemsForSelection, setItemsForSelection] = React.useState([]);

  const handleItemsForSelectionChange = (items) => {
    setItemsForSelection(items);
  };

  const displayedColumnsInitial = [
    { id: "userId", label: "#", minWidth: 60 },
    { id: "userCreated", label: "Créé le", minWidth: 60 },
    { id: "userFirstname", label: "Prénom", minWidth: 60 },
    { id: "userLastname", label: "Nom", minWidth: 60 },
    { id: "userMobile", label: "Mobile", minWidth: 60 },
    { id: "action", label: "Actions", minWidth: isMobile ? 90 : 120 },
  ];

  const displayedColumns = superUser
    ? displayedColumnsInitial
    : displayedColumnsInitial.filter((c) => c.id !== "___FIELDS_TO_EXCLUDE___");

  return (
    <PageWrapper>
      <RecordsBox items={items} itemsForSelection={itemsForSelection} />

      <StickyHeadTable
        businessType={businessType}
        superUser={superUser || true}
        filters={[
          "userCreated",
          "userFirstname",
          "userLastname",
          "userMobile",
          "userId",
        ]}
        columns={
          isMobile
            ? displayedColumns.filter(
                (c) =>
                  c.id === "userId" ||
                  c.id === "userFirstname" ||
                  c.id === "userLastname" ||
                  c.id === "action"
              )
            : displayedColumns
        }
        data={(items || []).map((i) => ({
          ...i,
          userCreated: dateFormat(i.userCreated, "mmm dS, H:MM"),
          userFirstname: i.userFirstname || "",
          userLastname: i.userLastname || "",
          userMobile: i.userMobile || "",
        }))}
        onDelete={onDelete}
        onEdit={onEdit}
        onItemsForSelectionChange={handleItemsForSelectionChange}
        onRefreshData={onRefreshData}
        checkboxEnabled={true}
      />
    </PageWrapper>
  );
};

export default AdminCustomers;
